module.exports = __webpack_public_path__ + "img/8.08c4e291.png";